import { api } from "./api";

export interface Review {
  _id: string;
  user: {
    _id: string;
    name: string;
    avatar?: string;
  };
  course: {
    _id: string;
    title: string;
    thumbnail?: string;
  };
  rating: number;
  comment: string;
  isApproved: boolean;
  helpful: number;
  createdAt: string;
}

export const reviewsApi = {
  // Get reviews for a course
  getCourseReviews: (courseId: string, options?: { page?: number; limit?: number; sort?: string }) => {
    const params = new URLSearchParams();
    if (options?.page) params.append("page", String(options.page));
    if (options?.limit) params.append("limit", String(options.limit));
    if (options?.sort) params.append("sort", options.sort);
    
    return api.get<{ success: boolean; count: number; data: Review[]; pagination: any }>(
      `/reviews/${courseId}${params.toString() ? `?${params.toString()}` : ""}`
    );
  },

  // Create a review for a course
  createReview: (courseId: string, data: { rating: number; comment: string }) => {
    return api.post<{ success: boolean; message: string; data: Review }>(
      `/reviews/${courseId}`,
      data
    );
  },

  // Update a review
  updateReview: (reviewId: string, data: { rating?: number; comment?: string }) => {
    return api.put<{ success: boolean; message: string; data: Review }>(
      `/reviews/${reviewId}`,
      data
    );
  },

  // Delete a review
  deleteReview: (reviewId: string) => {
    return api.delete<{ success: boolean; message: string }>(`/reviews/${reviewId}`);
  },

  // Mark review as helpful
  markHelpful: (reviewId: string) => {
    return api.post<{ success: boolean; message: string }>(`/reviews/${reviewId}/helpful`, {});
  },

  // Get user's reviews
  getUserReviews: (userId: string, options?: { page?: number; limit?: number }) => {
    const params = new URLSearchParams();
    if (options?.page) params.append("page", String(options.page));
    if (options?.limit) params.append("limit", String(options.limit));
    
    return api.get<{ success: boolean; count: number; data: Review[]; pagination: any }>(
      `/reviews/users/${userId}${params.toString() ? `?${params.toString()}` : ""}`
    );
  },

  // Get instructor's reviews
  getInstructorReviews: (options?: { page?: number; limit?: number; courseId?: string; sort?: string }) => {
    const params = new URLSearchParams();
    if (options?.page) params.append("page", String(options.page));
    if (options?.limit) params.append("limit", String(options.limit));
    if (options?.courseId) params.append("courseId", options.courseId);
    if (options?.sort) params.append("sort", options.sort);
    
    return api.get<{ 
      success: boolean; 
      count: number; 
      total: number;
      data: Review[]; 
      ratingStats: { courseId: string; courseTitle: string; courseThumbnail?: string; avgRating: number; totalReviews: number }[];
      pagination: any 
    }>(`/reviews/instructor${params.toString() ? `?${params.toString()}` : ""}`);
  },
};